module.exports = __webpack_public_path__ + "img/zj6.d75d7d1e.png";